import type { IDashboardTemplate } from "../types";
import { EFamilyTypes } from "../components/DashboardTemplatesTypes";
import { AssetsService } from "../../../../services/AssetsService";
import { i18nFilter } from "../../../../filters/i18nFilter";
import { SEGMENTS_FAMILY_NAME } from "app/components/widget/widget-utilities/segments/constants";
import { DEFAULT_DURATION_FOR_SEGMENTS } from "app/components/widget/widget-config/metrics/segments/utils";

const i18n = i18nFilter();

const segmentAnalysisTemplateConfig: IDashboardTemplate = {
    id: 14,
    title: "dashboard.templates.segmentAnalysis.title",
    description: "dashboard.templates.segmentAnalysis.description",
    descriptionLong: "dashboard.templates.segmentAnalysis.description.long",
    keyMetrics: "dashboard.templates.segmentAnalysis.keymetric",
    previewImage: AssetsService.assetUrl("/images/dashboard/templates/SegmentsTemplate-preview.png"),
    thumbnailImage: AssetsService.assetUrl("/images/dashboard/templates/SegmentsTemplate-thumb.png"),
    familyType: EFamilyTypes.Segments,
    minItems: 1,
    maxItems: 1,
    isNew: true,
    widgets: [
        {
            singleModeOnly: true,
            pos: {
                sizeX: 2,
                sizeY: 1,
                maxSizeY: 1,
                minSizeX: 2,
                maxSizeX: 4,
                row: 0,
                col: 0,
            },
            properties: {
                froWebSource: "Total",
                selectedChannel: "Direct",
                metric: "SegmentsMonthlyVisits",
                webSource: "Desktop",
                duration: DEFAULT_DURATION_FOR_SEGMENTS,
                type: "SegmentsMonthlyVisitsGraph",
                filters: {
                    ShouldGetVerifiedData: "true",
                    includeSubDomains: "true",
                    timeGranularity: "Monthly",
                },
                width: "2",
                customAsset: false,
                family: SEGMENTS_FAMILY_NAME,
                options: {},
                title: i18n("dashboards.wizard.segments.monthlyVisits.title"),
            },
        },
        {
            singleModeOnly: true,
            pos: {
                sizeX: 2,
                sizeY: 1,
                maxSizeY: 1,
                minSizeX: 2,
                maxSizeX: 4,
                row: 0,
                col: 2,
            },
            properties: {
                froWebSource: "Total",
                selectedChannel: "Direct",
                metric: "SegmentsTrafficShare",
                webSource: "Desktop",
                duration: DEFAULT_DURATION_FOR_SEGMENTS,
                type: "SegmentsTrafficShareGraph",
                filters: {
                    ShouldGetVerifiedData: "true",
                    includeSubDomains: "true",
                    timeGranularity: "Monthly",
                },
                width: "2",
                customAsset: false,
                family: SEGMENTS_FAMILY_NAME,
                options: {},
                title: i18n("segments.group.analysis.tab.trafficshare.title"),
            },
        },
        {
            singleModeOnly: true,
            pos: {
                sizeX: 2,
                sizeY: 1,
                maxSizeY: 1,
                minSizeX: 2,
                maxSizeX: 4,
                row: 1,
                col: 0,
            },
            properties: {
                froWebSource: "Total",
                selectedChannel: "Direct",
                metric: "SegmentsUniqueVisitors",
                webSource: "Desktop",
                duration: DEFAULT_DURATION_FOR_SEGMENTS,
                type: "SegmentsUniqueVisitorsGraph",
                filters: {
                    ShouldGetVerifiedData: "true",
                    includeSubDomains: "true",
                    timeGranularity: "Monthly",
                },
                width: "2",
                customAsset: false,
                family: SEGMENTS_FAMILY_NAME,
                options: {},
                title: i18n("folderanalysis.tabs.unique"),
            },
        },
        {
            singleModeOnly: true,
            pos: {
                sizeX: 2,
                sizeY: 1,
                maxSizeY: 1,
                minSizeX: 2,
                maxSizeX: 4,
                row: 1,
                col: 2,
            },
            properties: {
                froWebSource: "Total",
                selectedChannel: "Direct",
                metric: "SegmentsPageViews",
                webSource: "Desktop",
                duration: DEFAULT_DURATION_FOR_SEGMENTS,
                type: "SegmentsPageViewsGraph",
                filters: {
                    ShouldGetVerifiedData: "true",
                    includeSubDomains: "true",
                    timeGranularity: "Monthly",
                },
                width: "2",
                customAsset: false,
                family: SEGMENTS_FAMILY_NAME,
                options: {},
                title: i18n("folderanalysis.tabs.pageviews"),
            },
        },
        {
            singleModeOnly: true,
            pos: {
                sizeX: 2,
                sizeY: 1,
                maxSizeY: 1,
                minSizeX: 2,
                maxSizeX: 4,
                row: 2,
                col: 0,
            },
            properties: {
                froWebSource: "Total",
                selectedChannel: "Direct",
                metric: "SegmentsPagePerVisit",
                webSource: "Desktop",
                duration: DEFAULT_DURATION_FOR_SEGMENTS,
                type: "SegmentsPagePerVisitGraph",
                filters: {
                    ShouldGetVerifiedData: "true",
                    includeSubDomains: "true",
                    timeGranularity: "Monthly",
                },
                width: "2",
                customAsset: false,
                family: SEGMENTS_FAMILY_NAME,
                options: {},
                title: i18n("folderanalysis.tabs.pagespervisit"),
            },
        },
        {
            singleModeOnly: true,
            pos: {
                sizeX: 2,
                sizeY: 1,
                maxSizeY: 1,
                minSizeX: 2,
                maxSizeX: 4,
                row: 2,
                col: 2,
            },
            properties: {
                froWebSource: "Total",
                selectedChannel: "Direct",
                metric: "SegmentsVisitDuration",
                webSource: "Desktop",
                duration: DEFAULT_DURATION_FOR_SEGMENTS,
                type: "SegmentsVisitDurationGraph",
                filters: {
                    ShouldGetVerifiedData: "true",
                    includeSubDomains: "true",
                    timeGranularity: "Monthly",
                },
                width: "2",
                customAsset: false,
                family: SEGMENTS_FAMILY_NAME,
                options: {},
                title: i18n("folderanalysis.tabs.duration"),
            },
        },
        {
            singleModeOnly: true,
            pos: {
                sizeX: 2,
                sizeY: 1,
                maxSizeY: 1,
                minSizeX: 2,
                maxSizeX: 4,
                row: 3,
                col: 0,
            },
            properties: {
                froWebSource: "Total",
                selectedChannel: "Direct",
                metric: "SegmentsBounceRate",
                webSource: "Desktop",
                duration: DEFAULT_DURATION_FOR_SEGMENTS,
                type: "SegmentsBounceRateGraph",
                filters: {
                    ShouldGetVerifiedData: "true",
                    includeSubDomains: "true",
                    timeGranularity: "Monthly",
                },
                width: "2",
                customAsset: false,
                family: SEGMENTS_FAMILY_NAME,
                options: {},
                title: i18n("folderanalysis.tabs.bounce"),
            },
        },
        {
            singleModeOnly: true,
            pos: {
                sizeX: 2,
                sizeY: 1,
                maxSizeY: 1,
                minSizeX: 2,
                maxSizeX: 4,
                row: 3,
                col: 2,
            },
            properties: {
                froWebSource: "Total",
                selectedChannel: "Direct",
                metric: "SegmentsGeography",
                webSource: "Desktop",
                duration: DEFAULT_DURATION_FOR_SEGMENTS,
                type: "SegmentsGeographyTable",
                filters: {
                    ShouldGetVerifiedData: "true",
                    includeSubDomains: "true",
                    timeGranularity: "Monthly",
                },
                width: "2",
                customAsset: false,
                family: SEGMENTS_FAMILY_NAME,
                options: {},
                title: i18n("segments.group.analysis.tab.traffic_share_by_country.title"),
            },
        },
    ],
};

export default segmentAnalysisTemplateConfig;
